class VwKullaniciRolyetkiDTO {
    id?: number;
    yetkikodu?: string;
    fkGnlModulId?: number;
    yetkili?: string;
    kullaniciId?: number;
    treekey?: string;
    tipi?: number;
    seviye?: number;
    yetkiId?: number;
    bagliId?: number;
    yetkiadi?: string;
    yetkitipi?: number;
    link?: string;
    name?: string;
}
export default VwKullaniciRolyetkiDTO;